import * as React from "react";
import * as S from "@styled";
import { Uploader } from "../../shared/components/Uploader";
import { ElementImportViewModel, ImportSettings } from "../model/ImportModel";
import { ImportModal } from "./ImportModal";
import { Utilities } from "../utilities";

export class ProcessImporter extends React.Component<ImportProps, ImportState> {
    constructor(props: ImportProps) {
        super(props);
        this.state = this.getInitialState();
    }

    public render() {
        let modal;
        if (this.state.displayModal && this.state.importResult) {
            modal = <ImportModal
                onHide={this.resetState}
                elementImportViewModel={this.state.importResult}
                onImport={this.handleImport}
            />;
        }

        return (
            <S.Button>
                <Uploader
                    key={this.state.uploaderKey}
                    buttonText={"Import from file"}
                    resultHandler={this.handleUploadResponse}
                    uploadUrl="api/import/GetImportData"
                    accepts=".json"
                />
                {modal}
            </S.Button>
        );
    }

    private resetState = () => {
        this.setState(this.getInitialState());
    }

    private getInitialState(): ImportState {
        return {
            // Changing the uploader key forces re-rendering of the input.
            // This makes it possible to upload the same file multiple times and get the change event.
            uploaderKey: "uploader" + Date.now(),
            displayModal: false,
            importResult: null,
            file: null
        };
    }

    private handleUploadResponse = async (response: Response, file: File) => {
        await Utilities.parseJsonResponse<ElementImportViewModel>(response)
            .then((data) => {
                this.setState({
                    displayModal: true,
                    importResult: data, file: file,
                    uploaderKey: "uploader" + Date.now()
                });
            }).catch((error) => {
                this.props.onError(error);
                this.resetState();
            });
    }

    private handleImport = (settings: ImportSettings[]) => {
        this.props.onImport(settings, this.state.file);
    }
}

export interface ImportProps {
    onImport: (settings: ImportSettings[], file: File | null) => void;
    onError: (message: string) => void;
}

export interface ImportState {
    uploaderKey: string;
    importResult: ElementImportViewModel | null;
    file: File | null;
    displayModal: boolean;
}
